import { IconBell, IconSearchAlt, mapper } from '@maia/icons';
import { CardHeader, CardFooter, cardStyles, ActionButton } from '@maia/ui';
import { formatDate } from '@maia/utils';
import { twMerge } from 'tailwind-merge';

type ActivityCardProps = {
  title: string;
  subtitle: string;
  date: Date;
  icon: string;
  onOpen: () => void;
};

export function ActivityCard(props: ActivityCardProps) {
  const { title, subtitle, date, icon, onOpen } = props;

  return (
    <div className={twMerge(cardStyles({ variant: 'outlined' }), 'p-12')}>
      <CardHeader
        title={title}
        subtitle={subtitle}
        icon={mapper(icon)}
        actions={[
          <ActionButton icon={IconSearchAlt} size="small" onPress={onOpen} />,
        ]}
      />
      <CardFooter timestamp={{ date: formatDate(date) }} />
    </div>
  );
}
